import { HttpErrorResponse } from '@angular/common/http';

/** Тело ошибки бэкенда: { message, code, fieldErrors?: { nameRu: '...' } } */
interface ApiErrorBody {
  message?: unknown;
  fieldErrors?: Record<string, unknown>;
}

function errorBody(error: unknown): ApiErrorBody | null {
  const body = error instanceof HttpErrorResponse ? error.error : null;
  return body && typeof body === 'object' ? (body as ApiErrorBody) : null;
}

/** В ответе есть текст ошибки от бэкенда — его показывает форма, общий тост сервиса не нужен */
export function hasBackendMessage(error: unknown): boolean {
  return !!backendErrorText(error);
}

/** Текст ошибки бэкенда: message и сообщения полей без повторов; null — текста нет */
export function backendErrorText(error: unknown): string | null {
  const body = errorBody(error);
  if (!body) return null;
  const parts = [
    typeof body.message === 'string' ? body.message.trim() : '',
    ...Object.values(body.fieldErrors ?? {}).map(v => (typeof v === 'string' ? v.trim() : '')),
  ].filter((m, i, arr) => m && arr.indexOf(m) === i);
  return parts.length ? parts.join('. ') : null;
}
